const DomainConfigTypeEnum = Object.freeze({
  VONAGE: 'vonage',
  CSP: 'csp'
});

export default DomainConfigTypeEnum;
